import React from 'react';
import { Stack, IconButton } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import './ReportTable.css';

const RisksAndMitigation = ({ formData, handleRiskRowChange, addRiskRow, removeRiskRow }) => {
    return (
        <Stack spacing={3}>
            <MaterialTypography variant="h6" fontWeight="bold">
                Risks & Mitigation
            </MaterialTypography>
            <div className="report-table-container">
                <table className="report-table">
                    <thead>
                        <tr>
                            <th style={{ width: '30%' }}>Risk</th>
                            <th style={{ width: '30%' }}>Impact</th>
                            <th style={{ width: '30%' }}>Mitigation</th>
                            <th style={{ width: '10%' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formData.risks.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <MaterialInput
                                        multiline
                                        rows={3}
                                        value={row.risk}
                                        placeholder="Describe Risk"
                                        onChange={(e) => handleRiskRowChange(index, 'risk', e.target.value)}
                                        fullWidth
                                    />
                                </td>
                                <td>
                                    <MaterialInput
                                        multiline
                                        rows={3}
                                        value={row.impact}
                                        placeholder="Describe Impact"
                                        onChange={(e) => handleRiskRowChange(index, 'impact', e.target.value)}
                                        fullWidth
                                    />
                                </td>
                                <td>
                                    <MaterialInput
                                        multiline
                                        rows={3}
                                        value={row.mitigation}
                                        placeholder="Describe Mitigation"
                                        onChange={(e) => handleRiskRowChange(index, 'mitigation', e.target.value)}
                                        fullWidth
                                    />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <Stack direction="row" spacing={1} justifyContent="center">
                                        {index === formData.risks.length - 1 && (
                                            <IconButton color="success" onClick={addRiskRow}>
                                                <AddCircleIcon />
                                            </IconButton>
                                        )}
                                        {formData.risks.length > 1 && (
                                            <IconButton color="error" onClick={() => removeRiskRow(index)}>
                                                <RemoveCircleIcon />
                                            </IconButton>
                                        )}
                                    </Stack>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Stack>
    );
};

export default RisksAndMitigation;
